import(/* webpackMode: "eager" */ "/app/apps/nivex-frontend/src/app/error.tsx");
